import React, { useEffect, useState } from "react";
import {
  Alert,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  calculateReturnDate,
  countLeaveDays,
  createLeavePlan,
  getPublicHolidays,
} from "../../../store/leave/actions";
import { connect } from "react-redux";
import moment from "moment";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import ViewLeaveLetter from "./ViewLeaveLetter";
import {
  getDateOnly,
  isHoliday,
  isWeekend,
} from "../../common/components/Utils";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

const initialLoadingState = {
  countingDays: false,
  isLoadingData: true,
  isSubmitting: false,
};

const SplitAnnualLeaveForm = (props) => {
  const {
    showForm,
    setCloseForm,
    leave,
    allEmployeeLeavePlans,
    loading,
    user,
    selectedFiscalYear,
    publicHolidays,
    countLeaveDays,
    createLeavePlan,
    getPublicHolidays,
    calculateReturnDate,
  } = props;

  const [loadingState, setLoadingState] = useState(initialLoadingState);
  const [formData, setFormData] = useState({
    leavePlanId: null,
    previousId: null,
    startDate1: null,
    endDate1: null,
    startDate2: null,
    endDate2: null,
    startDate3: null,
    endDate3: null,
    comment: "",
  });
  const [numOfSplit, setNumOfSplit] = useState(2);
  const [maxDate, setMaxDate] = useState({
    start: new Date(selectedFiscalYear?.endOn),
    end: new Date(selectedFiscalYear?.endOn),
  });
  const [errors, setErrors] = useState({
    startDate1HasError: false,
    endDateHas1Error: false,
    startDate2HasError: false,
    endDateHas2Error: false,
    startDate3HasError: false,
    endDateHas3Error: false,
    messageHasError: false,
    messageErrorMessage: "",
  });
  const [plannedDays, setPlannedDays] = useState({
    split1: null,
    split2: null,
    split3: null,
  });

  useEffect(() => {
    if (!!showForm) {
      if (!!leave) {
        setFormData((prev) => ({
          ...prev,
          leavePlanId: leave.id,
          previousId: leave.postponedId,
        }));
      }

      if (publicHolidays.length === 0) {
        getPublicHolidays((status) =>
          setLoadingState((prev) => ({ ...prev, isLoadingData: status }))
        );
      } else {
        setLoadingState((prev) => ({ ...prev, isLoadingData: false }));
      }
    }

    return () => {
      setLoadingState(initialLoadingState);
    };
  }, [showForm]);

  const handleDatesToDisable = (date, level = 1) => {
    const isContractual = [18, 19, 20, 21].includes(+user.leaveDays);
    if (isWeekend(date) && isContractual) return true;
    if (isHoliday(publicHolidays, date) && isContractual) return true;

    let _leavePlans = (allEmployeeLeavePlans || []).filter(
      (plan) => plan.id !== leave?.id
    );

    if (level === 2) {
      _leavePlans = [
        ..._leavePlans,
        { startDate: formData.startDate1, endDate: formData.endDate1 },
      ];
    }
    if (level === 3) {
      _leavePlans = [
        ..._leavePlans,
        { startDate: formData.startDate1, endDate: formData.endDate1 },
        { startDate: formData.startDate2, endDate: formData.endDate2 },
      ];
    }

    const dates = _leavePlans.map(({ startDate, endDate }) => {
      const start = new Date(startDate);
      const end = new Date(endDate);
      return date >= start && date <= end;
    });
    return dates.includes(true);
  };

  const onClose = () => {
    // clean all states before close

    //   close form
    setCloseForm();
  };

  const handleCountLeaveDays = (level = 1, endDate = null) => {
    if (level === 1 && !!formData.startDate1 && !!endDate) {
      countLeaveDays(
        {
          startDate: formData.startDate1,
          endDate: endDate,
          leavePlanId: leave?.id || "",
          employeePositionId: leave?.employeePositionId || "",
          isPostponed: !!leave.postponedId,
        },
        (loading, data) => {
          setLoadingState((prev) => ({ ...prev, countingDays: loading }));
          if (!loading) setPlannedDays((prev) => ({ ...prev, split1: data }));
        }
      );
    }
    if (level === 2 && !!formData.startDate2 && !!endDate) {
      countLeaveDays(
        {
          startDate: formData.startDate2,
          endDate: endDate,
          leavePlanId: leave?.id || "",
          employeePositionId: leave?.employeePositionId || "",
          isPostponed: !!leave.postponedId,
        },
        (loading, data) => {
          console.log("oooo");
          setLoadingState((prev) => ({ ...prev, countingDays: loading }));
          if (!loading) setPlannedDays((prev) => ({ ...prev, split2: data }));
        }
      );
    }
    if (level === 3 && !!formData.startDate3 && !!endDate) {
      countLeaveDays(
        {
          startDate: formData.startDate3,
          endDate: endDate,
          leavePlanId: leave?.id || "",
          employeePositionId: leave?.employeePositionId || "",
          isPostponed: !!leave.postponedId,
        },
        (loading, data) => {
          setLoadingState((prev) => ({ ...prev, countingDays: loading }));
          if (!loading) setPlannedDays((prev) => ({ ...prev, split3: data }));
        }
      );
    }
  };

  const onSubmitRequest = () => {};

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showForm}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="text-dark pb-2">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "90%" }}
          >
            SPLIT ANNUAL LEAVE |{" "}
            <strong className="text-primary">{selectedFiscalYear?.name}</strong>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="py-1">
          <Typography
            variant="overline"
            className="font-weight-bold"
            display="block"
          >
            Current Leave Date
          </Typography>
          <div className="d-flex align-items-center mb-2">
            <span className="font-weight-bold">From</span>
            <input
              type="text"
              value={moment(leave.startDate).format("DD MMMM, YYYY")}
              className="mx-1 text-center rounded px-2 py-1"
              disabled
            />
            <span className="font-weight-bold">To</span>
            <input
              type="text"
              value={moment(leave.endDate).format("DD MMMM, YYYY")}
              className="ml-1 mr-1 text-center rounded px-2 py-1"
              disabled
            />

            <span className="badge badge-secondary text-left text-uppercase">
              <span className="badge badge-secondary bg-light text-secondary font-weight-bold">
                {leave.numOfDays}
              </span>{" "}
              <span>Days</span>
            </span>
          </div>

          <Divider className="mb-3">
            <Chip label="Split Leave Form" size="small" />
          </Divider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="mt-1">
              <div className="d-flex align-items-center">
                <DesktopDatePicker
                  label="Leave Start Date"
                  inputFormat="dd/MM/yyyy"
                  disabled={
                    loading ||
                    loadingState.countingDays ||
                    loadingState.isSubmitting ||
                    loadingState.isLoadingData
                  }
                  value={formData.startDate1}
                  onChange={(date) => {
                    setFormData({
                      ...formData,
                      startDate1: getDateOnly(date),
                      endDate1: null,
                    });
                    setPlannedDays((prev) => ({ ...prev, split1: null }));

                    setErrors({
                      ...errors,
                      startDate1HasError: false,
                    });
                  }}
                  minDate={
                    selectedFiscalYear && new Date(selectedFiscalYear?.startOn)
                  }
                  maxDate={maxDate.start}
                  renderInput={(params) => (
                    <TextField
                      onKeyDown={(e) => e.preventDefault()}
                      required={true}
                      fullWidth
                      size="small"
                      {...params}
                    />
                  )}
                  shouldDisableDate={handleDatesToDisable}
                  disablePast={true}
                />

                <span className="mx-2" style={{ fontSize: "30px" }}>
                  -
                </span>

                <DesktopDatePicker
                  label="Leave End Date"
                  inputFormat="dd/MM/yyyy"
                  disabled={
                    !formData.startDate1 ||
                    loading ||
                    loadingState.countingDays ||
                    loadingState.isSubmitting ||
                    loadingState.isLoadingData
                  }
                  defaultCalendarMonth={formData.startDate1 || new Date()}
                  value={formData.endDate1}
                  onChange={(date) => {
                    setFormData({
                      ...formData,
                      endDate1: getDateOnly(date),
                    });
                    setPlannedDays((prev) => ({ ...prev, split1: null }));
                    setErrors({
                      ...errors,
                      endDateHas1Error: false,
                    });
                    handleCountLeaveDays(1, getDateOnly(date));
                  }}
                  renderInput={(params) => (
                    <TextField
                      onKeyDown={(e) => e.preventDefault()}
                      required={true}
                      fullWidth
                      size="small"
                      {...params}
                    />
                  )}
                  minDate={formData.startDate1}
                  maxDate={maxDate.end}
                  shouldDisableDate={handleDatesToDisable}
                  disablePast={true}
                />

                <IconButton aria-label="add new split" size="small" disabled>
                  <AddRoundedIcon fontSize="inherit" />
                </IconButton>
              </div>

              {!!plannedDays.split1 && (
                <div className="d-flex align-items-center text-uppercase">
                  <span
                    className={`badge ${
                      plannedDays.split1.days > 0 &&
                      plannedDays.split1.days <= leave.numOfDays
                        ? "badge-secondary"
                        : "badge-danger"
                    } text-left text-uppercase mr-1`}
                    style={{ minWidth: "132px" }}
                    title="Planned days of leave"
                  >
                    <span
                      className={`badge badge-light${
                        plannedDays.split1.days > 0 &&
                        plannedDays.split1.days <= leave.numOfDays
                          ? " bg-secondary"
                          : " bg-danger"
                      } text-light`}
                      style={{ fontSize: "12px" }}
                    >
                      {plannedDays.split1.days}/{leave.numOfDays}
                    </span>{" "}
                    Planned days
                  </span>
                  <span
                    className="badge badge-warning text-left text-uppercase"
                    style={{ minWidth: "132px" }}
                    title="Other staff with same period of leave"
                  >
                    <span
                      className="badge badge-light bg-warning text-light"
                      // style={{ fontSize: "12px" }}
                    >
                      {plannedDays.split1.otherEmployeesWithLeave}
                    </span>{" "}
                    Other staff
                  </span>
                </div>
              )}
            </div>
            <div className="mt-1">
              <div className="d-flex align-items-center">
                <DesktopDatePicker
                  label="Leave Start Date"
                  inputFormat="dd/MM/yyyy"
                  disabled={
                    loading ||
                    loadingState.countingDays ||
                    loadingState.isSubmitting ||
                    loadingState.isLoadingData ||
                    !formData.endDate1
                  }
                  value={formData.startDate2}
                  onChange={(date) => {
                    setFormData({
                      ...formData,
                      startDate2: getDateOnly(date),
                      endDate2: null,
                    });
                    setPlannedDays((prev) => ({
                      ...prev,
                      split2: null,
                    }));
                    setErrors({
                      ...errors,
                      startDate2HasError: false,
                    });
                  }}
                  minDate={
                    selectedFiscalYear && new Date(selectedFiscalYear?.startOn)
                  }
                  maxDate={maxDate.start}
                  renderInput={(params) => (
                    <TextField
                      onKeyDown={(e) => e.preventDefault()}
                      required={true}
                      fullWidth
                      size="small"
                      {...params}
                    />
                  )}
                  shouldDisableDate={(d) => handleDatesToDisable(d, 2)}
                  disablePast={true}
                />

                <span className="mx-2" style={{ fontSize: "30px" }}>
                  -
                </span>

                <DesktopDatePicker
                  label="Leave End Date"
                  inputFormat="dd/MM/yyyy"
                  disabled={
                    !formData.startDate2 ||
                    loading ||
                    loadingState.countingDays ||
                    loadingState.isSubmitting ||
                    loadingState.isLoadingData
                  }
                  defaultCalendarMonth={formData.startDate2 || new Date()}
                  value={formData.endDate2}
                  onChange={(date) => {
                    setFormData({
                      ...formData,
                      endDate2: getDateOnly(date),
                    });
                    setPlannedDays((prev) => ({ ...prev, split2: null }));
                    setErrors({
                      ...errors,
                      endDateHas2Error: false,
                    });
                    handleCountLeaveDays(2, getDateOnly(date));
                  }}
                  renderInput={(params) => (
                    <TextField
                      onKeyDown={(e) => e.preventDefault()}
                      required={true}
                      fullWidth
                      size="small"
                      {...params}
                    />
                  )}
                  minDate={formData.startDate2}
                  maxDate={maxDate.end}
                  shouldDisableDate={(d) => handleDatesToDisable(d, 2)}
                  disablePast={true}
                />
                <IconButton
                  aria-label="add new split"
                  size="small"
                  color="primary"
                  onClick={() => setNumOfSplit((prev) => prev + 1)}
                  disabled={
                    numOfSplit > 2 ||
                    !formData.endDate2 ||
                    (plannedDays.split1?.days || 0) +
                      (plannedDays.split2?.days || 0) >=
                      leave.numOfDays
                  }
                >
                  <AddRoundedIcon fontSize="inherit" />
                </IconButton>
              </div>

              {!!plannedDays.split2 && (
                <div className="d-flex align-items-center text-uppercase">
                  <span
                    className={`badge ${
                      plannedDays.split2.days > 0 &&
                      plannedDays.split2.days <= leave.numOfDays
                        ? "badge-secondary"
                        : "badge-danger"
                    } text-left text-uppercase mr-1`}
                    style={{ minWidth: "132px" }}
                    title="Planned days of leave"
                  >
                    <span
                      className={`badge badge-light${
                        plannedDays.split2.days > 0 &&
                        plannedDays.split2.days <= leave.numOfDays
                          ? " bg-secondary"
                          : " bg-danger"
                      } text-light`}
                      style={{ fontSize: "12px" }}
                    >
                      {plannedDays.split2.days}/{leave.numOfDays}
                    </span>{" "}
                    Planned days
                  </span>
                  <span
                    className="badge badge-warning text-left text-uppercase"
                    style={{ minWidth: "132px" }}
                    title="Other staff with same period of leave"
                  >
                    <span
                      className="badge badge-light bg-warning text-light"
                      // style={{ fontSize: "12px" }}
                    >
                      {plannedDays.split2.otherEmployeesWithLeave}
                    </span>{" "}
                    Other staff
                  </span>
                </div>
              )}
            </div>
            {numOfSplit === 3 && (
              <div className="mt-1">
                <div className="d-flex align-items-center">
                  <DesktopDatePicker
                    label="Leave Start Date"
                    inputFormat="dd/MM/yyyy"
                    disabled={
                      loading ||
                      loadingState.countingDays ||
                      loadingState.isSubmitting ||
                      loadingState.isLoadingData ||
                      !formData.endDate2
                    }
                    value={formData.startDate3}
                    onChange={(date) => {
                      setFormData({
                        ...formData,
                        startDate3: getDateOnly(date),
                        endDate3: null,
                      });
                      setPlannedDays((prev) => ({ split3: null, ...prev }));

                      setErrors({
                        ...errors,
                        startDate3HasError: false,
                      });
                    }}
                    minDate={
                      selectedFiscalYear &&
                      new Date(selectedFiscalYear?.startOn)
                    }
                    maxDate={maxDate.start}
                    renderInput={(params) => (
                      <TextField
                        onKeyDown={(e) => e.preventDefault()}
                        required={true}
                        fullWidth
                        size="small"
                        {...params}
                      />
                    )}
                    shouldDisableDate={(d) => handleDatesToDisable(d, 3)}
                    disablePast={true}
                  />

                  <span className="mx-2" style={{ fontSize: "30px" }}>
                    -
                  </span>

                  <DesktopDatePicker
                    label="Leave End Date"
                    inputFormat="dd/MM/yyyy"
                    disabled={
                      !formData.startDate3 ||
                      loading ||
                      loadingState.countingDays ||
                      loadingState.isSubmitting ||
                      loadingState.isLoadingData
                    }
                    defaultCalendarMonth={formData.startDate3 || new Date()}
                    value={formData.endDate3}
                    onChange={(date) => {
                      setFormData({
                        ...formData,
                        endDate3: getDateOnly(date),
                      });
                      setPlannedDays((prev) => ({ split3: null, ...prev }));
                      setErrors({
                        ...errors,
                        endDateHas3Error: false,
                      });
                      handleCountLeaveDays(3, getDateOnly(date));
                    }}
                    renderInput={(params) => (
                      <TextField
                        onKeyDown={(e) => e.preventDefault()}
                        required={true}
                        fullWidth
                        size="small"
                        {...params}
                      />
                    )}
                    minDate={formData.startDate3}
                    maxDate={maxDate.end}
                    shouldDisableDate={(d) => handleDatesToDisable(d, 3)}
                    disablePast={true}
                  />
                  <IconButton
                    aria-label="remove third split"
                    size="small"
                    color="error"
                    onClick={() => {
                      setNumOfSplit((prev) => prev - 1);
                      setFormData((prev) => ({
                        ...prev,
                        startDate3: null,
                        endDate3: null,
                      }));
                    }}
                  >
                    <RemoveRoundedIcon fontSize="inherit" />
                  </IconButton>
                </div>

                {!!plannedDays.split3 && (
                  <div className="d-flex align-items-center text-uppercase">
                    <span
                      className={`badge ${
                        plannedDays.split3.days > 0 &&
                        plannedDays.split3.days <= leave.numOfDays
                          ? "badge-secondary"
                          : "badge-danger"
                      } text-left text-uppercase mr-1`}
                      style={{ minWidth: "132px" }}
                      title="Planned days of leave"
                    >
                      <span
                        className={`badge badge-light${
                          plannedDays.split3.days > 0 &&
                          plannedDays.split3.days <= leave.numOfDays
                            ? " bg-secondary"
                            : " bg-danger"
                        } text-light`}
                        style={{ fontSize: "12px" }}
                      >
                        {plannedDays.split3.days}/{leave.numOfDays}
                      </span>{" "}
                      Planned days
                    </span>
                    <span
                      className="badge badge-warning text-left text-uppercase"
                      style={{ minWidth: "132px" }}
                      title="Other staff with same period of leave"
                    >
                      <span className="badge badge-light bg-warning text-light">
                        {plannedDays.split3.otherEmployeesWithLeave}
                      </span>{" "}
                      Other staff
                    </span>
                  </div>
                )}
              </div>
            )}
          </LocalizationProvider>
        </DialogContent>
        <DialogActions className="py-2">
          <div className="d-flex justify-content-center w-100">
            <button
              onClick={onSubmitRequest}
              type="button"
              className="btn btn-sm btn-primary text-uppercase px-5"
              disabled={
                loading ||
                !plannedDays?.split1?.days ||
                !plannedDays?.split2?.days ||
                (plannedDays?.split1?.days || 0) +
                  (plannedDays?.split2?.days || 0) +
                  (plannedDays?.split3?.days || 0) !==
                  leave.numOfDays ||
                loadingState.countingDays ||
                loadingState.isLoadingData ||
                loadingState.isSubmitting
              }
            >
              {loadingState.isSubmitting ? "Wait..." : "Submit"}
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({
  loading,
  user,
  selectedFiscalYear,
  publicHolidays,
}) => {
  return {
    loading,
    user,
    selectedFiscalYear,
    publicHolidays,
  };
};
export default connect(mapStateToProps, {
  countLeaveDays,
  createLeavePlan,
  getPublicHolidays,
  calculateReturnDate,
})(SplitAnnualLeaveForm);
